import { render, staticRenderFns } from "./sInputs.vue?vue&type=template&id=0f0a7d86&scoped=true&"
import script from "./sInputs.vue?vue&type=script&lang=js&"
export * from "./sInputs.vue?vue&type=script&lang=js&"
import style0 from "./sInputs.vue?vue&type=style&index=0&id=0f0a7d86&scoped=true&lang=css&"
import style1 from "./sInputs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a7d86",
  null
  
)

export default component.exports